import { takeEvery, put, call, select } from 'redux-saga/effects';
import * as types from '../constants/ActionTypes';
import Api from '../functions/Api';

export function* fetchPartnerData() {
  try {
    const { data: payload } = yield call(Api.get, 'partner/');
    yield put({
      type: types.FETCH_PARTNER_DATA_SUCCESS,
      payload,
    });
  } catch (error) {
    yield put({
      type: types.FETCH_PARTNER_DATA_FAILURE,
      error,
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* updatePartnerData({ data }) {
  try {
    const { data: payload } = yield call(Api.put, 'partner/', {
      data,
    });
    yield put({
      type: types.UPDATE_PARTNER_DATA_SUCCESS,
      payload,
    });
  } catch (error) {
    yield put({
      type: types.UPDATE_PARTNER_DATA_FAILURE,
      error,
    });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* fetchAffiliatePartner() {
  try {
    const { data } = yield call(Api.get, `v2/affiliate/`);
    yield put({ type: types.FETCH_AFFILIATE_PARTNER_SUCCESS, data });
  } catch (error) {
    yield put({ type: types.FETCH_AFFILIATE_PARTNER_FAILURE, error });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export function* updateAffiliatePartner({ data }) {
  const affiliateId = yield select((state) => state.partner.affiliate.id);
  const method = affiliateId ? 'put' : 'post';
  try {
    const { data: payload } = yield call(Api[method], `v2/affiliate/`, {
      data,
    });
    yield put({ type: types.UPDATE_AFFILIATE_PARTNER_SUCCESS, payload });
  } catch (error) {
    yield put({ type: types.UPDATE_AFFILIATE_PARTNER_FAILURE, error });
    yield put({ type: types.NETWORK_ERROR, error });
  }
}

export default function* watchPartner() {
  yield takeEvery(types.FETCH_PARTNER_DATA, fetchPartnerData);
  yield takeEvery(types.UPDATE_PARTNER_DATA, updatePartnerData);
  yield takeEvery(types.UPDATE_AFFILIATE_PARTNER, updateAffiliatePartner);
  yield takeEvery(types.FETCH_AFFILIATE_PARTNER, fetchAffiliatePartner);
}
